import Index from '@/pages/function/Index'
import List from '@/pages/function/List'
import Create from '@/pages/function/Create'
import Modify from '@/pages/function/Modify'

var serviceName = process.env.VUE_APP_SERVICE_NAME || 'Nichibyo'

export default {
  path: 'function',
  component: Index,
  children: [
    {
      path: 'index',
      component: List
    },
    {
      path: 'create',
      component: Create,
      props: () => ({serviceName: serviceName})
    },
    {
    path: 'modify/:id',
    component: Modify,
    props: () => ({serviceName: serviceName})
    }
  ]
}